import React from 'react';
import Page from './layout/Page';
import Loader from './Loader';

export default function PageLoader() {
	return (
		<Page className="page-loader">
			<Loader />
		</Page>
	);
}
